import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "background-modal" }
const _hoisted_2 = { class: "wrapper-modal" }
const _hoisted_3 = { class: "wrapper-title" }
const _hoisted_4 = { class: "wrapper-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseButton = _resolveComponent("CloseButton")!
  const _component_GeneralInput = _resolveComponent("GeneralInput")!
  const _component_GeneralSelect = _resolveComponent("GeneralSelect")!
  const _component_StandardButton = _resolveComponent("StandardButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "title" }, "Información del usuario", -1)),
        _createVNode(_component_CloseButton, { onClick: _ctx.closeModal }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_GeneralInput, {
          text: _ctx.name.val,
          "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name.val) = $event)),
          value: _ctx.name.val,
          label: 'Nombre',
          "has-error": _ctx.name.enabled,
          error: _ctx.name.errors.length === 0 ? '' : _ctx.name.errors[0],
          class: "input-full"
        }, null, 8, ["text", "value", "has-error", "error"]),
        _createVNode(_component_GeneralInput, {
          text: _ctx.userName.val,
          "onUpdate:text": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userName.val) = $event)),
          value: _ctx.userName.val,
          label: 'Nombre de usuario',
          "has-error": _ctx.userName.enabled,
          error: _ctx.userName.errors.length === 0 ? '' : _ctx.userName.errors[0],
          "is-disabled": _ctx.isEdit
        }, null, 8, ["text", "value", "has-error", "error", "is-disabled"]),
        _createVNode(_component_GeneralSelect, {
          text: _ctx.role.val,
          "onUpdate:text": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.role.val) = $event)),
          options: _ctx.roles,
          value: _ctx.role.val,
          label: 'Rol',
          "has-error": _ctx.role.enabled,
          error: _ctx.role.errors.length === 0 ? '' : _ctx.role.errors[0]
        }, null, 8, ["text", "options", "value", "has-error", "error"]),
        _createVNode(_component_GeneralInput, {
          text: _ctx.code.val,
          "onUpdate:text": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.code.val) = $event)),
          value: _ctx.code.val,
          label: 'Código empleado',
          "has-error": _ctx.code.enabled,
          error: _ctx.code.errors.length === 0 ? '' : _ctx.code.errors[0]
        }, null, 8, ["text", "value", "has-error", "error"]),
        _createVNode(_component_GeneralInput, {
          text: _ctx.price.val,
          "onUpdate:text": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.price.val) = $event)),
          value: _ctx.price.val,
          label: 'Precio base',
          "has-error": _ctx.price.enabled,
          error: _ctx.price.errors.length === 0 ? '' : _ctx.price.errors[0]
        }, null, 8, ["text", "value", "has-error", "error"]),
        _createVNode(_component_GeneralInput, {
          text: _ctx.password.val,
          "onUpdate:text": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.password.val) = $event)),
          value: _ctx.password.val,
          label: 'Contraseña',
          "has-error": _ctx.password.enabled && !_ctx.isEdit,
          error: _ctx.password.errors.length === 0 ? '' : _ctx.password.errors[0]
        }, null, 8, ["text", "value", "has-error", "error"]),
        _createVNode(_component_GeneralInput, {
          text: _ctx.email.val,
          "onUpdate:text": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.email.val) = $event)),
          value: _ctx.email.val,
          label: 'Correo',
          "has-error": _ctx.email.enabled,
          error: _ctx.email.errors.length === 0 ? '' : _ctx.email.errors[0]
        }, null, 8, ["text", "value", "has-error", "error"])
      ]),
      _createVNode(_component_StandardButton, {
        buttonLabel: 'Guardar',
        class: "margin-button",
        "is-disabled": _ctx.disabledForm,
        onClick: _ctx.createEditUser
      }, null, 8, ["is-disabled", "onClick"])
    ])
  ]))
}